<template>
  <div id="contenedor-main-estadisticas-estimaciones">
    <Estadisticas
    titulo="Estadisticas - Estimaciones"
    :datosMostrar="datosMostrar"/>
  </div>
</template>

<script>
import Estadisticas from '@/components/administracion/contratos/estadisticas/Main.vue';

export default {
  name: 'MainEstadisticasEstimaciones',
  components: {
    Estadisticas,
  },
  data() {
    return {
      datosMostrar: [
        'contatos',
        'conAnticipo',
        'conAnticipoPorSolicitar',
        'sinAnticipo',
        // con anticipo solicitado
        // con anticipo solicitado por pagar
        // con anticipo solicitado pagado
        'sinCatalogo',
        'sinPrograma',
        'sinDeducciones',
        'sinEstimaciones',
        'terminadosSinEstimacionFiniquito',
        // Con solicitud de pago de pendientes
        // Con pagos solicitados pendientes
      ],
    };
  },

};
</script>

<style>

</style>
